import {
  BgColorType,
  Copyright,
  FlexContainer,
  Footer,
  FooterLogo,
  LocaleDictionaryType,
  SocialMedia,
  SocialMediaPropsType,
  TabBarMenu,
  TabBarMenuTabType,
  useLocales,
  useScreenWidth,
} from "@/lib/main";

type Props = SocialMediaPropsType & {
  bgColor?: BgColorType;
  breakpoint?: number;
  showTabBarMenu?: boolean;
  tabBarMenuTabs?: TabBarMenuTabType[];
  showCopyright?: boolean;
  showLogo?: boolean;
  tagline?: LocaleDictionaryType;
  showSocialMedia?: boolean;
};

export default function FooterChildren({
  bgColor,
  breakpoint,
  showTabBarMenu,
  tabBarMenuTabs,
  showCopyright,
  showLogo,
  tagline,
  showSocialMedia,
  ...socialMediaProps
}: Props) {
  const l = useLocales();
  const { screenWidth } = useScreenWidth();

  if (!showLogo && !showSocialMedia && !showCopyright && !showTabBarMenu) {
    return null;
  }

  if (breakpoint && screenWidth < breakpoint) {
    if (showTabBarMenu && tabBarMenuTabs && tabBarMenuTabs!.length === 0) {
      return null;
    }

    if (
      breakpoint &&
      showTabBarMenu &&
      tabBarMenuTabs &&
      tabBarMenuTabs.length > 0
    ) {
      return (
        <Footer breakpoint={breakpoint} showTabBarMenu={showTabBarMenu}>
          <TabBarMenu tabs={tabBarMenuTabs} />
        </Footer>
      );
    }
  }

  return (
    <Footer
      bgColor={bgColor || "footer"}
      breakpoint={breakpoint}
      showTabBarMenu={showTabBarMenu}
    >
      <FlexContainer direction="column" gap="lg">
        <div>
          {showLogo ? (
            <FooterLogo slogan={tagline ? l(tagline) : undefined} />
          ) : null}
        </div>

        {showSocialMedia ? <SocialMedia {...socialMediaProps} /> : null}

        {showCopyright ? <Copyright /> : null}
      </FlexContainer>
    </Footer>
  );
}
